import UserRepository from '../../repositories/UserRepository';
// import TranslatorServerRepository from '../../repositories/TranslatorServerRepository'
// import Vue from 'vue'

export default {
	namespaced: true,
	state: {

	},
	mutations: {

	},
	actions: {
		fetchAll ({ commit, getters }) {
			return UserRepository.all();
			// return TranslatorServerRepository.all()
		},
		postNew ({ commit, getters }, request) {
			return UserRepository.create(request);
		},
		updateUser ({ commit, getters }, request) {
			return UserRepository.update(request.user_id, request);
		},
		activateUser ({ commit, getters }, userId) {
			return UserRepository.activate(userId);
		},
		deactivateUser ({ commit, getters }, userId) {
			return UserRepository.deactivate(userId);
		},
		updatePassword ({ commit, getters }, form) {
			return UserRepository.updatePassword(form);
		},
		updateProfile ({ commit, getters }, form) {
			return UserRepository.updateProfile(form);
		},
		removeUser ({ commit, getters }, userId) {
			return UserRepository.removeUser(userId);
		},
		assignRoles ({ getters }, form) {
			return UserRepository.updateRoles(form);
		}
	},
	getters: {
	}
};
